package org.gymly.data

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

/**
 * Avisa al gate de términos del portal que el servidor bloqueó al socio, por ejemplo porque el personal
 * usó "Reenviar términos" mientras el socio ya estaba dentro. El gate vuelve a consultar y muestra la aceptación.
 */
object PortalTermsGuard {
    private val revisions = MutableStateFlow(0)

    val revision: StateFlow<Int> = revisions.asStateFlow()

    fun requestRecheck() {
        revisions.update { it + 1 }
    }
}
